import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

export const getDecryptedUrl = async (params: any) => {
  try {
    const response = await postCall(urlConfig.DecryptUrl, params);
    return response.data;
  } catch (error) {
    console.error("Error in Decrypt URL ", error);
    throw error;
  }
};